import { render } from "./tab-1.vue?vue&type=template&id=25fa1239"
import script from "./tab-1.vue?vue&type=script&lang=js"
export * from "./tab-1.vue?vue&type=script&lang=js"
script.render = render

export default script